// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v7Uu","list":"styles_list__2cwcv","disableSelection":"styles_disableSelection__2ul-6"};